import { useState } from 'react'

import {
  Text,
  SequenceMenu,
  SequenceMenuItemType,
  Center,
  Box,
  Flex
} from '@sequencehq/core-components'
import {
  Primary12SemiBold,
  GreyGrey60,
  GreyGrey20,
  Primary13Regular,
  GreyGrey80,
  Primary13SemiBold
} from '@sequencehq/core-components'

const CellComponent = ({
  value,
  otherRows,
  strong = false,
  indentation = 0
}: {
  value: string
  otherRows?: string[]
  strong?: boolean
  indentation?: 0 | 1
}) => {
  return (
    <Flex
      flexDir="column"
      paddingY="8px"
      paddingLeft={`${indentation * 4 + 4}px`}
      gap="8px"
    >
      <Text
        {...(strong ? Primary13SemiBold : Primary13Regular)}
        color={GreyGrey80}
      >
        {value}
      </Text>

      {otherRows?.map((row, index) => (
        <Text
          key={index}
          {...Primary13Regular}
          color={GreyGrey60}
          whiteSpace="pre-line"
          noOfLines={3}
        >
          {row}
        </Text>
      ))}
    </Flex>
  )
}

const Header = ({ value }: { value: string }) => (
  <Text {...Primary12SemiBold} color={GreyGrey60} paddingY="8px">
    {value}
  </Text>
)

const Skeleton = () => (
  <Box
    width="70%"
    height="8px"
    borderRadius="8px"
    background={GreyGrey20}
    alignSelf="center"
  />
)

const KebabMenu = ({ items }: { items: SequenceMenuItemType[] }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Center
      boxSize="32px"
      opacity={isOpen ? '1' : '0'}
      _groupHover={{ opacity: 1 }}
      data-testid="invoice.lineItems.kebabMenu"
    >
      <SequenceMenu
        variant="ghost"
        buttonSize="small"
        items={items}
        onOpenChange={setIsOpen}
      />
    </Center>
  )
}

export const Cell = Object.assign(CellComponent, {
  Header,
  Skeleton,
  KebabMenu
})
